import React from 'react';
import { ArrowRight } from 'lucide-react';
import photoHeader from '../assets/photo-header.jpg';

export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      const targetPos = target.getBoundingClientRect().top + window.scrollY - 16;
      window.scrollTo({ top: targetPos, behavior: 'smooth' });
    }
  };

  return (
    <section className="hero" id="home" style={{ ['--hero-photo' as any]: `url(${photoHeader})` }}>
      <div className="hero-content">
        <span className="eyebrow">Berthoud, Colorado</span>
        <h1>Growth That Belongs.</h1>
        <p className="hero-subtitle">
          A community-first development company honoring Berthoud&rsquo;s heritage while planning what comes next.
        </p>
        <div className="hero-actions">
          <a href="#projects" className="btn btn-on-dark" onClick={(e) => handleClick(e, '#projects')}>
            See what we&rsquo;re building
            <ArrowRight className="btn-icon" strokeWidth={1.5} aria-hidden="true" />
          </a>
          <a href="#approach" className="btn btn-secondary" onClick={(e) => handleClick(e, '#approach')} style={{ color: 'var(--gs-paper)', borderColor: 'rgba(243,239,230,0.5)' }}>
            Our approach
          </a>
        </div>
      </div>
    </section>
  );
}
